import b from 'b_';
import PropTypes from 'prop-types';
import React from 'react';

import './datetimepicker__input.scss';
import { MODES } from '../constants';

function DatetimepickerInput(props) {
    const {
        blurCallbacks,
        changeCallbacks,
        day,
        focusCallbacks,
        hour,
        isDateFocused,
        isNowSelected,
        isTimeFocused,
        minute,
        mode,
        month,
        nowLabel = 'Сейчас',
        refCallbacks,
        revealNow,
        year,
    } = props;

    if (isNowSelected) {
        return (
            <div className="datetimepicker__input" onClick={revealNow}>
                <div className="datetimepicker__now">{nowLabel}</div>
            </div>
        );
    }

    return (
        <div className="datetimepicker__input">
            <div className={b('datetimepicker__input-date', { focused: isDateFocused })}>
                <input
                    className="datetimepicker__input-day"
                    onBlur={blurCallbacks.day}
                    onChange={changeCallbacks.day}
                    onFocus={focusCallbacks.day}
                    placeholder="--"
                    ref={refCallbacks.day}
                    value={day}
                />
                <span className="datetimepicker__dot">.</span>
                <input
                    className="datetimepicker__input-month"
                    onBlur={blurCallbacks.month}
                    onChange={changeCallbacks.month}
                    onFocus={focusCallbacks.month}
                    placeholder="--"
                    ref={refCallbacks.month}
                    value={month}
                />
                <span className="datetimepicker__dot">.</span>
                <input
                    className="datetimepicker__input-year"
                    onBlur={blurCallbacks.year}
                    onChange={changeCallbacks.year}
                    onFocus={focusCallbacks.year}
                    placeholder="----"
                    ref={refCallbacks.year}
                    value={year}
                />
            </div>
            {mode === MODES.DATETIME && (
                <div className={b('datetimepicker__input-time', { focused: isTimeFocused })}>
                    <input
                        className="datetimepicker__input-hour"
                        onBlur={blurCallbacks.hour}
                        onChange={changeCallbacks.hour}
                        onFocus={focusCallbacks.hour}
                        placeholder="--"
                        ref={refCallbacks.hour}
                        value={hour}
                    />
                    <span className="datetimepicker__colon">:</span>
                    <input
                        className="datetimepicker__input-minute"
                        onBlur={blurCallbacks.minute}
                        onChange={changeCallbacks.minute}
                        onFocus={focusCallbacks.minute}
                        placeholder="--"
                        ref={refCallbacks.minute}
                        value={minute}
                    />
                </div>
            )}
        </div>
    );
}

DatetimepickerInput.propTypes = {
    blurCallbacks: PropTypes.object.isRequired,
    changeCallbacks: PropTypes.object.isRequired,
    day: PropTypes.string,
    focusCallbacks: PropTypes.object.isRequired,
    hour: PropTypes.string,
    isDateFocused: PropTypes.bool,
    isNowSelected: PropTypes.bool,
    isTimeFocused: PropTypes.bool,
    minute: PropTypes.string,
    mode: PropTypes.oneOf(Object.values(MODES)).isRequired,
    month: PropTypes.string,
    nowLabel: PropTypes.string,
    refCallbacks: PropTypes.object.isRequired,
    revealNow: PropTypes.func.isRequired,
    year: PropTypes.string,
};

export default DatetimepickerInput;
